import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { isTypedBackendError, mapBackendErrorToMessage } from '@tradgine/data-access/backend-errors';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((err: unknown) => {
            if (err instanceof HttpErrorResponse) {
                const message = handleHttpError(err);
                return throwError(() => new Error(message));
            }

            return throwError(() => new Error('Unexpected error occurred.'));
        })
    );
};

export function handleHttpError(err: HttpErrorResponse): string {
    const backendError = err.error;

    if (isTypedBackendError(backendError)) {
        return mapBackendErrorToMessage(backendError);
    }

    if (typeof backendError?.message === 'string') {
        return backendError.message;
    }

    if (err.status === 0) {
        return 'Network error. Please check your connection.';
    }

    return 'Something went wrong. Please try again later.';
}
